export function downloadBase64File(base64: string, filename: string, mimeType: string) {
  const isSafari =
    typeof window.TEST_FAKE_SAFARI === 'boolean'
      ? window.TEST_FAKE_SAFARI
      : /constructor/i.test(window.HTMLElement as any) ||
        (p => {
          return p.toString() === '[object SafariRemoteNotification]';
        })(
          !window.safari ||
            (typeof window.safari !== 'undefined' && window.safari.pushNotification),
        );

  const isIOS =
    typeof window.TEST_FAKE_IOS === 'boolean'
      ? window.TEST_FAKE_IOS
      : /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  const type = isSafari ? 'application/octet-stream' : mimeType;

  const a = document.createElement('a');

  let hrefUrl = '';
  if (isIOS) {
    const binary = atob(base64.replace(/\s/g, ''));
    const len = binary.length;
    const buffer = new ArrayBuffer(len);
    const byteArray = new Uint8Array(buffer);
    for (let i = 0; i < len; i++) {
      byteArray[i] = binary.charCodeAt(i);
    }

    hrefUrl = window.URL.createObjectURL(new Blob([byteArray], { type }));
    a.target = '_blank';
  } else {
    hrefUrl = `data:${type};base64,${base64}`;
    a.download = filename;
  }

  a.href = hrefUrl;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
